import { useEffect, useId, useRef, useState } from "react";
import { editorInputClassName } from "../../common/editor/editorStyles";

export function entityOptionLabel(row) {
	return row?.title || row?.name || row?.phone_number || `#${row?.id ?? ""}`;
}

export default function AdminEntitySearchSelect({
	value,
	onChange,
	options,
	searchQuery,
	onSearchQueryChange,
	placeholder = "انتخاب کنید…",
	required = false,
}) {
	const listId = useId();
	const rootRef = useRef(null);
	const searchRef = useRef(null);
	const [open, setOpen] = useState(false);

	const selectedRow = options.find(
		(row) => String(row.id) === String(value)
	);
	const buttonLabel = value
		? selectedRow
			? entityOptionLabel(selectedRow)
			: searchQuery || `#${value}`
		: "";

	useEffect(() => {
		if (!open) return undefined;
		const onDoc = (e) => {
			if (rootRef.current && !rootRef.current.contains(e.target)) {
				setOpen(false);
			}
		};
		document.addEventListener("mousedown", onDoc);
		const t = window.setTimeout(() => searchRef.current?.focus(), 0);
		return () => {
			document.removeEventListener("mousedown", onDoc);
			window.clearTimeout(t);
		};
	}, [open]);

	function pick(row) {
		onChange(String(row.id), row);
		setOpen(false);
	}

	return (
		<div ref={rootRef} className="relative w-full">
			<input
				type="hidden"
				value={value || ""}
				required={required}
				tabIndex={-1}
				aria-hidden
				onChange={() => {}}
			/>
			<button
				type="button"
				aria-expanded={open}
				aria-haspopup="listbox"
				aria-controls={listId}
				onClick={() => setOpen((v) => !v)}
				className={[
					editorInputClassName,
					"flex w-full items-center justify-between gap-2 text-right",
				].join(" ")}
			>
				<span
					className={
						value ? "truncate text-darkBlue" : "truncate text-darkBlue/40"
					}
				>
					{value ? buttonLabel : placeholder}
				</span>
				<svg
					width="18"
					height="18"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth="2"
					className={[
						"shrink-0 text-darkBlue/50 transition",
						open ? "rotate-180" : "",
					].join(" ")}
					aria-hidden
				>
					<path d="M6 9l6 6 6-6" />
				</svg>
			</button>

			{open && (
				<div
					className={[
						"absolute left-0 right-0 top-[calc(100%+6px)] z-40 overflow-hidden",
						"rounded-[12px] border border-darkBlue/15 bg-white shadow-[0_12px_32px_rgba(39,106,166,0.15)]",
					].join(" ")}
				>
					<div className="border-b border-darkBlue/10 p-2">
						<input
							ref={searchRef}
							type="search"
							value={searchQuery}
							onChange={(e) => onSearchQueryChange(e.target.value)}
							placeholder="جستجو…"
							className={[
								editorInputClassName,
								"py-2.5 text-[13px]",
							].join(" ")}
							autoComplete="off"
						/>
					</div>
					<ul
						id={listId}
						role="listbox"
						className="max-h-[240px] overflow-y-auto py-1"
					>
						{options.length === 0 && (
							<li className="px-4 py-3 text-center font-Vazir-400 text-[13px] text-darkBlue/45">
								موردی یافت نشد
							</li>
						)}
						{options.map((row) => {
							const active = String(row.id) === String(value);
							return (
								<li key={row.id} role="option" aria-selected={active}>
									<button
										type="button"
										onClick={() => pick(row)}
										className={[
											"flex w-full px-4 py-2.5 text-right font-Vazir-400 text-[14px] transition",
											active
												? "bg-cta/10 text-cta"
												: "text-darkBlue hover:bg-lightCta/80",
										].join(" ")}
									>
										{entityOptionLabel(row)}
									</button>
								</li>
							);
						})}
					</ul>
				</div>
			)}
		</div>
	);
}
